import React from 'react';
import { Home } from 'lucide-react';
import { AREA_CHIPS, IMAGES } from '../mock';

export default function Area() {
  return (
    <section id="obszar" className="bg-white py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">OBSZAR DZIAŁANIA</div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <h2 className="font-heading font-extrabold text-[36px] md:text-[48px] leading-[1.05] tracking-tight text-[#0f1a2b]">
              Działam na terenie całej Polski.
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-[#0f1a2b]/75 max-w-xl">
              Świadczę usługi inżynieryjne na terenie całego kraju. Największą aktywność zawodową koncentruję w promieniu około 50 km od siedziby firmy, natomiast projekty, wyceny, doradztwo techniczne oraz nadzory realizuję dla klientów z każdej części Polski.
            </p>

            <div className="mt-8 flex items-start gap-4 rounded-2xl bg-[#f5f5f7] border border-slate-200 p-5">
              <div className="h-11 w-11 rounded-lg bg-[#f5c518] flex items-center justify-center flex-shrink-0">
                <Home className="h-5 w-5 text-[#0f1a2b]" />
              </div>
              <div>
                <div className="text-[11px] font-semibold tracking-[0.2em] text-[#0f1a2b]/60">SIEDZIBA</div>
                <div className="font-heading font-bold text-[18px] text-[#0f1a2b] mt-0.5">Klonowa 3, 64-140 Włoszakowice</div>
                <p className="mt-1 text-[13px] text-[#0f1a2b]/65">Najczęściej pracuję w obrębie 50 km, ale zdarzają się realizacje na terenie całego kraju.</p>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              {AREA_CHIPS.map((c) => (
                <span key={c} className="text-[13px] bg-white border border-slate-300 rounded-full px-4 py-2 text-[#0f1a2b]">{c}</span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-2xl overflow-hidden border border-slate-200 bg-gradient-to-br from-white to-[#f5f7fa]">
              <img
                src={IMAGES.polandMap}
                alt="Mapa Polski - obszar działania firmy z siedzibą w Włoszakowicach"
                className="w-full h-auto block"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
